import axiosInstance from '../helpers/axios.helper';

const getData = (params, options = {}) => {
  return axiosInstance.get('api/v2/reports/leads/sales_funnel_statistics', { params }, options);
};

export const salesFunnelService = {
  getData
};



// WEBPACK FOOTER //
// ./src/services/salesFunnel.service.js